import { render, staticRenderFns } from "./11introduce.vue?vue&type=template&id=4ffefc77&scoped=true&"
import script from "./11introduce.vue?vue&type=script&lang=js&"
export * from "./11introduce.vue?vue&type=script&lang=js&"
import style0 from "./11introduce.vue?vue&type=style&index=0&id=4ffefc77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffefc77",
  null
  
)

export default component.exports